"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageName = void 0;
__exportStar(require("../../../../lib/google/protobuf/any_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/protobuf/any_pb"), exports);
__exportStar(require("../../../../lib/google/protobuf/descriptor_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/protobuf/descriptor_pb"), exports);
__exportStar(require("../../../../lib/google/protobuf/duration_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/protobuf/duration_pb"), exports);
__exportStar(require("../../../../lib/google/protobuf/field_mask_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/protobuf/field_mask_pb"), exports);
__exportStar(require("../../../../lib/google/protobuf/struct_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/protobuf/struct_pb"), exports);
__exportStar(require("../../../../lib/google/protobuf/wrappers_grpc_web_simple_client"), exports);
__exportStar(require("../../../../lib/google/protobuf/wrappers_pb"), exports);
exports.packageName = "google.protobuf";
//# sourceMappingURL=index.js.map